import styled from 'styled-components';

export const WrapItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 80%;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: baseline;
  }
`;

export const Container = styled.div`
  background: #fff;
  border: 1px solid #c9c9c9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 36px;
  border-radius: 4px;
  box-shadow: 3px 5px 20px rgb(0 0 0 / 20%);

  & + div {
    margin-top: 16px;
  }
`;

export const TypeDescription = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #000fff;
`;

export const ContractNumberText = styled.span`
  font-size: 16px;
  color: #000fff;
`;

export const DataWrap = styled.div``;

export const DataLabel = styled.span`
  font-size: 16px;
  color: #000fff;
`;

export const DataText = styled.span`
  font-size: 16px;
  color: #808495;
  margin-left: 8px;
`;

export const Controllers = styled.div`
  position: relative;
  margin-left: 16px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    width: 1px;
    background: #c9c9c9;
    height: 98px;
    left: -12px;
    transform: translateY(-50%);
  }
`;
